export const COLORS = {
	WHITE: "#FFFFFF",
	// PRIMARY
	DARK_BLUE: "#00161E",
	PRIMARY_BLUE: "#70C6E6",
	PRIMARY_GREEN: "#4DD5C0",
	// SECONDARY
	SMOOTH_BLACK: "#353841",
	PRIMARY_PURPLE: "#8461B3",
	// GRADIENTS
	BLUE_TO_GREEN: "linear-gradient(90deg, #0099D2 -8.02%, #4DD5C0 69.83%)",
	SPACE: "linear-gradient(138deg, #FFFFFF 18.04%, #4DD5C0 94.96%)",
	PIANO: "linear-gradient(180deg, rgba(202, 116, 194, 0.9)  0%, rgba(53, 56, 65, 0.45) 100%)",
};
